module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/advertisers/slots/slots.component.css
// module id = ./src/app/advertisers/slots/slots.component.css
// module chunks = main